import * as Sentry from "@sentry/vue"
import type { App } from "vue"

let initialized = false

// Sentry is initialised once per page; every Vue app mounted afterwards just
// gets the error handler attached.
export default function (app: App, environment: string): void {
  if (initialized) {
    Sentry.attachErrorHandler(app, { attachProps: true })
    return
  }

  initialized = true
  Sentry.init({
    app,
    environment,
    dsn: "https://17cedb0d6da54807953a4200804df82e@o341047.ingest.sentry.io/4504795282079744",
    integrations: [Sentry.browserTracingIntegration()],
    // Still no tracesSampleRate, so no transaction is ever sampled — these
    // only decide which requests carry trace headers.
    tracePropagationTargets: [
      "localhost",
      "app.iqrecruit.com",
      "app.iqrecruit.dev",
      /^\//,
    ],
  })
}
